export default __webpack_public_path__ + "static/media/collaborer.6d839398.png";